export default __webpack_public_path__ + "static/media/picto-admin.b693c424.png";